import type { RootState } from 'state';
import type { LanguagesState } from '../slice';

function getLanguages(state: RootState): LanguagesState['value'] {
  const { value } = state.dataService.staticData.languages;
  return value;
}

export default getLanguages;
